import { render, staticRenderFns } from "./LwfPhoto.vue?vue&type=template&id=61c54140&scoped=true&"
import script from "./LwfPhoto.vue?vue&type=script&lang=js&"
export * from "./LwfPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c54140",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
